"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTopAreaNavigation = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
var _logger = require("../logger");
var _net = require("../models/graphql-types/net");
var _utils = require("../utils");
// istanbul ignore file -- api

const logger = _logger.mainLogger.createChild('getTopAreaNavigation');
const getTopAreaNavigation = async ({
  language,
  staticApiUrl,
  tenant
}) => {
  const staticApiClient = new _staticApiClientReact.ApiClient({
    baseUrl: staticApiUrl,
    language,
    tenant
  });
  try {
    const {
      data
    } = await (0, _staticApiClientReact.getTenantApplicationsNavigationExpandedNavigation)(staticApiClient, tenant, _net.NavigationType.TopAreaNavigation, {
      lang: language
    });
    return (0, _utils.mapNavigationData)(data.data?.application?.navigation?.children);
  } catch (error) {
    logger.error(new Error('Failed to fetch top area navigation', {
      cause: error
    }));
    return [];
  }
};
exports.getTopAreaNavigation = getTopAreaNavigation;